import React, { useEffect } from 'react';
import { Card } from '../components/ui/card';
import PhotoGallery from '../components/PhotoGallery';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';
import { Home, Users, Bed, Bath, Wifi, UtensilsCrossed, Waves, Fish, WashingMachine, Snowflake, Car, Ban, Ruler, Shirt, CalendarCheck } from 'lucide-react';

const DieVilla = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    { icon: CalendarCheck, text: t('villa.features.completion') },
    { icon: Ruler, text: t('villa.features.plot') },
    { icon: Home, text: t('villa.features.livingSpace') },
    { icon: Users, text: t('villa.features.guests') },
    { icon: Bed, text: t('villa.features.bedrooms') },
    { icon: Bath, text: t('villa.features.bathrooms') },
    { icon: Wifi, text: t('villa.features.wifi') },
    { icon: UtensilsCrossed, text: t('villa.features.kitchen') },
    { icon: Waves, text: t('villa.features.pool') },
    { icon: Fish, text: t('villa.features.seaAccess') },
    { icon: WashingMachine, text: t('villa.features.washer') },
    { icon: Shirt, text: t('villa.features.linens') },
    { icon: Snowflake, text: t('villa.features.aircon') },
    { icon: Car, text: t('villa.features.parking') },
    { icon: Ban, text: t('villa.features.noPets'), isWarning: true },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white">
      {/* Header */}
      <Header />

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-6xl pt-28">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 text-center">{t('villa.title')}</h1>
        
        {/* Ausstattung */}
        <Card className="p-6 md:p-8 border-amber-200 hover:shadow-lg transition-shadow duration-300 mb-12">
          <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-6 text-center">{t('villa.equipment')}</h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className={`flex items-center gap-3 p-3 rounded-lg bg-amber-50 hover:bg-amber-100 transition-colors duration-300 ${
                  feature.isWarning ? 'border border-red-200 bg-red-50 hover:bg-red-100' : ''
                }`}
              >
                <feature.icon className={`w-5 h-5 flex-shrink-0 ${
                  feature.isWarning ? 'text-red-500' : 'text-amber-600'
                }`} />
                <span className={`text-sm md:text-base ${
                  feature.isWarning ? 'text-red-700' : 'text-gray-700'
                }`}>
                  {feature.text}
                </span>
              </div>
            ))}
          </div>

          {/* Zusätzliche Küchen-Details */}
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600 text-center">
              <strong>{t('villa.kitchenEquipment')}</strong> {t('villa.kitchenDetails')}
            </p>
          </div>
        </Card>
        
        {/* Fotogalerie */}
        <div>
          <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">{t('villa.gallery')}</h2>
          <PhotoGallery />
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 mt-16">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400">
            {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default DieVilla;
